import './ScrollableCalendar.css';
export default {
    "scrollableCalendar": "ScrollableCalendar_scrollableCalendar__u5w4e",
    "months": "ScrollableCalendar_months__u5w4e",
    "scrollableList": "ScrollableCalendar_scrollableList__u5w4e"
};
